import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ApiService } from '../../../../custom-services/ApiService';
import { environment } from '../../../../../environments/environment';


@Component({
    selector: 'app-tds-info-return-v2',
    templateUrl: './tds-info-return-v2.component.html',
    styleUrls: ['./tds-info-return-v2.component.css'],
    standalone: false
})
export class TdsInfoReturnV2Component implements OnInit, OnChanges {
  constructor(private apiService: ApiService) { }
  @Input() printActive: boolean;
  @Input() returnData: any;
  @Input() isSinglePageReturn: boolean;
  section163ForwardData: any;
  challanBaseUrl: string;
  importTdsInfo: any;
  otherTdsInfo: any;
  currentAY: string = '2026-2027';

  protected readonly window = window;

  ngOnInit(): void {
    this.getImportData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getChallanBaseUrl();
    this.section163ForwardData = this.returnData?.taxPaymentData?.tc_S_Tax_163_Forward ?
      Math.round(this.returnData?.taxPaymentData?.tc_S_Tax_163_Forward) : 0;
  }


  private getImportData() {

    const list = this.returnData?.paymentDetails?.otherTds?.list || [];

    this.importTdsInfo = list.filter(
      (item: any) => item.section === 'Import [ Section-120]'
    );

    this.otherTdsInfo = list.filter(
      (item: any) => item.section !== 'Import [ Section-120]'
    );



  }
  private getChallanBaseUrl() {
    if (environment.production) {
      this.challanBaseUrl = 'https://achallan.gov.bd/acs/General/PrintChallanSlipDetails?challanNo=';
    } else {
      this.challanBaseUrl = 'https://training.finance.gov.bd/acs/General/PrintChallanSlipDetails?challanNo=';
    }
  }
}
